import { useTranslation } from 'react-i18next'
import { useInView } from 'react-intersection-observer'
import { isEmpty } from 'remeda'
import { ProductsSlider } from '@components/ProductsSlider/ProductsSlider'
import { dataTestIds } from '@velasca/constants'
import { useRelatedProducts } from '@velasca/hooks/use-related-products'
import { trackEvent } from '@velasca/utils/track-event'
import type { SimilarProductsSliderProps } from './SimilarProductsSlider.types'

const quickAddEvent = (handle: string) => {
  trackEvent({
    googleAnalytics: {
      eventName: 'related_quick_add',
      data: { handle },
    },
  })
}

export const SimilarProductsSlider = ({
  className,
  sliderStyles,
  productHandle,
  parentLoading = false,
  arrowVisible = false,
  breakpoints,
}: SimilarProductsSliderProps) => {
  const [ref, inView] = useInView({
    rootMargin: '0px 0px 200px 0px',
    triggerOnce: true,
  })
  const { t } = useTranslation('product')

  const { data, loading } = useRelatedProducts({
    type: 'similar',
    productHandle,
    skip: !inView,
  })

  if ((!data || isEmpty(data)) && !loading && inView) {
    return null
  }

  return (
    <ProductsSlider
      showProductType
      ref={ref}
      className={`product-slider ${className || ''}`}
      sliderStyles={sliderStyles}
      products={data}
      loading={loading || parentLoading || !inView}
      title={t('relatedProductsTitle')}
      subTitle={t('relatedProductsSubTitle')}
      arrowVisible={arrowVisible}
      breakpoints={breakpoints}
      dataTestId={dataTestIds.SIMILAR_PRODUCTS_SLIDER}
      onQuickAdd={quickAddEvent}
      onAddToCart={(handle) => {
        trackEvent({
          googleAnalytics: {
            eventName: 'related_quick_add_to_cart',
            data: { handle },
          },
        })
      }}
    />
  )
}
